import React, { useEffect } from 'react'
import {
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  TablePagination
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { useTable, usePagination, useRowSelect } from 'react-table'

export default function DataTable(props) {
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  const { columns, data, rowsPerPageOptions, onSelect } = props

  /**
  |--------------------------------------------------
  | useTable Hook
  |--------------------------------------------------
  */
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    setPageSize,
    gotoPage,
    selectedFlatRows,
    state: { pageIndex, pageSize, selectedRowPaths }
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: props.pageSize || 10 }
    },
    usePagination,
    useRowSelect
  )

  /**
  |--------------------------------------------------
  | Change Row Per Page
  |--------------------------------------------------
  */
  function hadleChangeRowsPerPage(event) {
    setPageSize(+event.target.value)
    gotoPage(0)
  }

  /**
  |--------------------------------------------------
  | Handle Change Page
  |--------------------------------------------------
  */
  function handleChangePage(event, page) {
    gotoPage(page)
  }

  /**
  |--------------------------------------------------
  | On Select Handler
  |--------------------------------------------------
  */
  useEffect(() => {
    onSelect({ selectedFlatRows, selectedRowPaths })
  }, [onSelect, selectedFlatRows, selectedRowPaths])

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  return (
    <>
      <Table {...getTableProps()}>
        {/* HEADER */}
        <TableHead>
          {headerGroups.map(headerGroup => (
            <StyledTableRow {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <StyledTableCell {...column.getHeaderProps()}>
                  {column.render('Header')}
                </StyledTableCell>
              ))}
            </StyledTableRow>
          ))}
        </TableHead>
        {/* HEADER */}

        {/* BODY */}
        <TableBody {...getTableBodyProps()}>
          {page.map(
            row =>
              prepareRow(row) || (
                <StyledTableRow {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    return (
                      <StyledTableCell {...cell.getCellProps()}>
                        {cell.render('Cell')}
                      </StyledTableCell>
                    )
                  })}
                </StyledTableRow>
              )
          )}
        </TableBody>
        {/* BODY */}
      </Table>

      {/* PAGINATION */}
      <TablePagination
        page={pageIndex}
        component="div"
        rowsPerPage={pageSize}
        count={data.length}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={hadleChangeRowsPerPage}
        rowsPerPageOptions={rowsPerPageOptions || [10, 25, 50, 100]}
      />
      {/* PAGINATION */}
    </>
  )
}

/**
|--------------------------------------------------
| Default Props
|--------------------------------------------------
*/
DataTable.defaultProps = {
  columns: [{ Header: 'No.' }],
  data: [],
  onSelect: () => { }
}

/**
|--------------------------------------------------
| Styles
|--------------------------------------------------
*/
const StyledTableCell = withStyles(theme => ({
  root: {
    padding: '10px 10px',

  },
  head: {
    backgroundColor: theme.palette.grey[600],
    color: theme.palette.grey[300],
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },

}))(TableCell)

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:hover': {
      background: theme.palette.grey[700]
    }
  }
}))(TableRow)
